import { GuestTravelInquiry, TravelInquiryCreateRequest } from "../../../../../shared/types/travelInquiry";
import { RegistrationTravelRequest } from "../../../shared/types";
import { GuestTravelFormValues } from "../../../shared/types/travel";
import {
	TravelSegmentCreateRequest,
	TravelSegmentFormValues,
	isTravelSegmentFormValues,
	isTravelSegmentIndexResource,
} from "../../../shared/types/travelSegment";

const mapGuestTravelInquiryToRequest = (inquiry: GuestTravelInquiry): TravelInquiryCreateRequest => {
	switch (inquiry.type) {
		case "flight":
			return {
				type: inquiry.type,
				earliestDepartureDate: inquiry.earliestDepartureDate,
				earliestDepartureTime: inquiry.earliestDepartureTime,
				latestArrivalDate: inquiry.latestArrivalDate,
				latestArrivalTime: inquiry.latestArrivalTime,
				arrivalLocation: inquiry.arrivalLocation?.iataCode || "",
				departureLocation: inquiry.departureLocation?.iataCode || "",
				remarks: inquiry.remarks,
			};
		case "train":
			return inquiry;
	}
};

const mapTravelSegmentFormValuesToFormRequest = (formValues: TravelSegmentFormValues): TravelSegmentCreateRequest => {
	switch (formValues.type) {
		case "flight":
			return {
				type: "flight",
				arrivalDate: formValues.arrivalDate,
				arrivalTime: formValues.arrivalTime,
				arrivalLocation: formValues.arrivalLocation?.iataCode ?? "",
				departureDate: formValues.departureDate,
				departureTime: formValues.departureTime,
				departureLocation: formValues.departureLocation?.iataCode ?? "",
				identifier: formValues.identifier,
				serviceClass: formValues.serviceClass,
			};
		case "car":
		case "train":
			return formValues;
	}
};

export const mapGuestTravelToRegistrationTravelRequest = (travel: GuestTravelFormValues): RegistrationTravelRequest => {
	return {
		id: travel.id === -1 ? null : travel.id,
		arrival: {
			travelSegmentIds: travel.arrivals.filter(isTravelSegmentIndexResource).map(({ id }) => id),
			travelSegmentRequests: travel.arrivals
				.filter(isTravelSegmentFormValues)
				.map(mapTravelSegmentFormValuesToFormRequest),
			travelInquiryRequest: travel.arrivalInquiry ? mapGuestTravelInquiryToRequest(travel.arrivalInquiry) : null,
			selfTravelRequest: travel.arrivalSelfTravel,
			travelTemplateId: travel.arrivalTravelTemplate?.id || null,
		},
		departure: {
			travelSegmentIds: travel.departures.filter(isTravelSegmentIndexResource).map(({ id }) => id),
			travelSegmentRequests: travel.departures
				.filter(isTravelSegmentFormValues)
				.map(mapTravelSegmentFormValuesToFormRequest),
			travelInquiryRequest: travel.departureInquiry ? mapGuestTravelInquiryToRequest(travel.departureInquiry) : null,
			selfTravelRequest: travel.departureSelfTravel,
			travelTemplateId: travel.departureTravelTemplate?.id || null,
		},
	};
};
